import { Component, OnInit } from '@angular/core';
import { environment } from '@app/env';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { CookieUtilsService } from '@app/shared/utils/cookie-utils.service';
import { Observable } from 'rxjs';
import { AnalyticsHelperService } from 'src/app/modules/evc-small-biz/services/analytics-helper.service';
import { SmallBizStoreService } from 'src/app/modules/evc-small-biz/stores/small-biz-store.service';
import { fadeInUp } from '../../../animations/fly-animations';
import { IModalNavigator } from '../../../component-lib/components/modal/navigator/modal-navigator.interface';
import { IMultiModalComponent } from '../../../component-lib/components/modal/navigator/multi-modal-component.interface';
import { ButtonStateEnum } from '../../../component-lib/enums/button-state.enum';
import { ChargingIntroductionComponent } from '../../introduction/introduction.component';
import { IntroductionType } from '../../introduction/introduction.model';
import { ChargingCardOutboundInfoComponent } from '../outbound/info/info.component';
import { ChargingCardInputModel } from './charging-card-input.model';
import { ChargingCardInputService } from './charging-card-input.service';

@Component({
  selector: 'evsb-charging-card-input',
  templateUrl: './charging-card-input.component.html',
  animations: [fadeInUp('200ms')],
})
export class ChargingCardInputComponent implements OnInit, IMultiModalComponent {
  public model: ChargingCardInputModel;
  public modalNavigator: IModalNavigator;

  public value = 0;
  public minCards = 1;
  public maxCards = environment.maxChargingCards;
  public canGoBack = true;
  public unitPrice$: Observable<number>;

  public submitBtnState: ButtonStateEnum;

  constructor(
    private pageService: ChargingCardInputService,
    private analyticsService: AnalyticsService,
    private analyticsHelperService: AnalyticsHelperService,
    private store: SmallBizStoreService,
    private cookieUtilsService: CookieUtilsService
  ) {}

  ngOnInit(): void {
    this.model = this.pageService.getModel();
    this.value = this.pageService.getValue();
    this.unitPrice$ = this.pageService.getUnitPrice();
    this.canGoBack = this.cookieUtilsService.getCookie(IntroductionType.skipIntroChargingCard) === 'true';
    this.updateSubmitBtnState();
    this.analytics();
  }

  public valueChange(value: number) {
    this.value = value;
    this.updateSubmitBtnState();

    if (value > this.maxCards) {
      this.value = this.maxCards;
      this.navigateToOutbound();
    }
  }

  public add(): void {
    this.store.setChargeCards(this.value);
    this.analyticsAdd();
    this.modalNavigator.close();
  }

  public goBack(): void {
    this.cookieUtilsService.setCookie(IntroductionType.skipIntroChargingCard, false);

    const modalInstance = this.modalNavigator.goToView(ChargingIntroductionComponent) as ChargingIntroductionComponent;
    modalInstance.data = { introductionType: IntroductionType.skipIntroChargingCard };
  }

  private navigateToOutbound(): void {
    const modalInstance = this.modalNavigator.goToView(
      ChargingCardOutboundInfoComponent
    ) as ChargingCardOutboundInfoComponent;
  }

  private updateSubmitBtnState() {
    if (this.value < this.minCards || this.value > this.maxCards) {
      return (this.submitBtnState = ButtonStateEnum.disabled);
    }

    return (this.submitBtnState = ButtonStateEnum.enabled);
  }

  private analytics(): void {
    this.analyticsService.push({
      event: 'b-to-b-ev-simulator-flow',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'step-charging-card',
      eventLabel: 'modify-quantity',
    });
  }

  private analyticsAdd(): void {
    this.analyticsHelperService.analyticsWorkflowStep('overview/product-added');

    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'step-charging-card',
      eventLabel: 'add-solution-charging-card',
    });
  }
}
